<template>
  <div>
    <only-site-card :com_data="com_data">
      <template v-slot:item_edit>
        <ValidationObserver ref="observer">
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="2">
                <div class="font-weight-bold mb-2">女性からのメッセージ</div>
                <p class="red--text mini">
                  未入力の場合、コメントタブの「<strong>セラピストコメント</strong>」の内容で更新します。
                </p>
              </v-col>
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col col="12">
                    <div class="mt-1 mb-1">
                      <span class="font-weight-bold text-align-middle"
                        >HTML用&nbsp;</span
                      ><v-btn
                        text
                        color="primary"
                        class="font-weight-bold pa-1 d-inline"
                        @click="onHtmlClear('cast')"
                        >HTMLをクリア</v-btn
                      >
                    </div>
                    <div class="">
                      <ckeditor-component
                        ref="refCommentByCastCkeditor"
                        :data="cast_prop.lady_lmsg"
                      ></ckeditor-component>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-10"></v-divider>
            <v-row>
              <v-col cols="12" sm="2">
                <div class="font-weight-bold mb-2">店舗からのメッセージ</div>
                <p class="red--text mini">
                  未入力の場合、コメントタブの「<strong>お店コメント</strong>」の内容で更新します。
                </p>
              </v-col>
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col col="12">
                    <div class="mt-1 mb-1">
                      <span class="font-weight-bold text-align-middle"
                        >HTML用&nbsp;</span
                      ><v-btn
                        text
                        color="primary"
                        class="font-weight-bold pa-1 d-inline"
                        @click="onHtmlClear('shop')"
                        >HTMLをクリア</v-btn
                      >
                    </div>
                    <div class="">
                      <ckeditor-component
                        ref="refCommentByShopCkeditor"
                        :data="cast_prop.lady_mesg"
                      ></ckeditor-component>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-10"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">新人属性</span></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="6" sm="4" md="2">
                    <v-select
                      ref="lady_rookie"
                      v-model="cast_prop.lady_rookie"
                      name="lady_rookie"
                      :items="rookieItem"
                      :no-data-text="items.lady_rookie.text"
                      :label="items.lady_rookie.text"
                      :hint="`新人選択で入店日から30日間は「新人アイコン」が付きます`"
                      persistent-hint
                      success
                      outlined
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-divider class="mt-4 mb-8"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><div class="font-weight-bold">タグ設定</div>
                <div class="mini">
                  <div>VOTECのバージョンによっては利用できない項目です</div>
                </div>
              </v-col>
              <v-col cols="12" sm="10">
                タグを{{
                  items.tag_list.counter
                }}個以内で選択してください。※VOTEC側で指定した場合のみ、項目が表示されます。
                <div v-if="loadingFlg" class="mt-2 grey--text">
                  <v-progress-circular
                    indeterminate
                    size="20"
                    width="2"
                    class="mr-2"
                  ></v-progress-circular>
                  タグを取得中...
                </div>
                <ValidationProvider
                  v-else-if="checkTagList.length > 0"
                  v-slot="{ errors, valid }"
                  :name="items.tag_list.text"
                  :rules="items.tag_list.rules"
                >
                  <div v-if="!valid" class="red--text">
                    <span
                      v-if="
                        checkTagListSelected.length > items.tag_list.counter
                      "
                      >最大{{
                        items.tag_list.counter
                      }}個まで選択できます。</span
                    >
                  </div>
                  <v-row class="mt-2 mb-2">
                    <v-col
                      v-for="tagText in checkTagList"
                      :key="tagText"
                      cols="4"
                      sm="3"
                      md="2"
                    >
                      <v-checkbox
                        class="mt-1"
                        ref="tag_list"
                        v-model="checkTagListSelected"
                        name="tag_list"
                        :label="tagText"
                        :value="tagText"
                        :success="valid"
                        :error="!valid"
                        hide-details
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </ValidationProvider>
              </v-col>
            </v-row>

            <v-divider class="mt-4 mb-10"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">TwitterID</span>
                <div class="mini">
                  <div>VOTECのバージョンによっては利用できない項目です</div>
                </div>
              </v-col>
              <v-col cols="6" sm="3">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.lady_kana.text"
                      :rules="items.lady_kana.rules"
                    >
                      <v-text-field
                        ref="lady_kana"
                        v-model="cast_prop.lady_kana"
                        name="lady_kana"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.lady_kana.text"
                        placeholder=""
                        persistent-hint
                        outlined
                        hint="https://twitter.com/この部分"
                        :counter="items.lady_kana.counter"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-divider class="mt-4 mb-10"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">流れる文字</span>
                <div class="mini">
                  <div>VOTECのバージョンによっては利用できない項目です</div>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      ref="lady_flow_text"
                      v-model="cast_prop.lady_flow_text"
                      name="lady_flow_text"
                      success
                      :label="items.lady_flow_text.text"
                      placeholder=""
                      persistent-hint
                      outlined
                      hint="6文字以上で文字が流れます"
                      :counter="items.lady_flow_text.counter"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-divider class="mt-4 mb-10"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold"
                  >写メ日記ウィジェット</span
                ></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      ref="lady_widget_diary"
                      v-model="cast_prop.lady_widget_diary"
                      name="lady_widget_diary"
                      success
                      rows="4"
                      outlined
                      :label="items.lady_widget_diary.text"
                      persistent-hint
                      hint="写メ日記ウィジェットを挿入できます。ウィジェットコードを貼り付けてください"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-divider class="mt-4 mb-10"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">口コミウィジェット</span></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      ref="lady_widget_review"
                      v-model="cast_prop.lady_widget_review"
                      name="lady_widget_review"
                      success
                      rows="4"
                      outlined
                      :label="items.lady_widget_review.text"
                      persistent-hint
                      hint="口コミウィジェットを挿入できます。ウィジェットコードを貼り付けてください"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </ValidationObserver>
      </template>
    </only-site-card>
  </div>
</template>

<script>
import {
  set,
  ref,
  reactive,
  toRefs,
  defineComponent,
  onMounted,
} from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import utilFunc from "@/common/utilFunc.js";
import retryRequest from "@/common/retryRequest";

export default defineComponent({
  props: ["com_data"],
  setup(props, ctx) {
    const refCommentByCastCkeditor = ref(null);
    const refCommentByShopCkeditor = ref(null);

    const CastPropsRepository = repositoryFactory.get("castProps");
    const SynchroRepository = repositoryFactory.get("synchro");

    const state = reactive({
      errorElement: null,
      cast_prop: {},
      // 読み込み時データ保持(保存前比較用)
      keepData: {
        cast_prop: {},
      },
      // タグ設定 checkTagList
      checkTagList: [],
      checkTagListSelected: [],
      loadingFlg: false,
      isError: false,
    });

    const rookieItem = [
      { value: "", text: "未指定" },
      { value: "1", text: "新人" },
      { value: "2", text: "キャリア" },
    ];

    const items = {
      "lady_lmsg": {
        text: "女性からのメッセージ",
        rules: "",
        counter: "",
      },
      "lady_mesg": {
        text: "店舗からのメッセージ",
        rules: "",
        counter: "",
      },
      "lady_rookie": {
        text: "新人属性",
        rules: "required",
        counter: "",
      },
      "lady_kana": {
        text: "TwitterID",
        rules: "twitter2",
        counter: "",
      },
      "lady_flow_text": {
        text: "流れる文字",
        rules: "",
        counter: "",
      },
      "lady_widget_diary": {
        text: "写メ日記ウィジェット",
        rules: "",
        counter: "",
      },
      "lady_widget_review": {
        text: "口コミウィジェット",
        rules: "",
        counter: "",
      },
      "tag_list": {
        text: "タグ設定",
        rules: "check_max:4",
        counter: "4",
      },
    };

    // 画面表示用にstate.cast_propの値を整理(媒体コピー処理からreflectCastPropsで呼ばれる)
    const reflectCastProps = async () => {
      // タグ設定の初期値セット
      if (state.cast_prop.tag_list) {
        state.checkTagListSelected = JSON.parse(state.cast_prop.tag_list);
      }
    };

    const getTagList = async () => {
      state.isError = false;
      state.loadingFlg = true;
      state.checkTagList.splice(0);
      try {
        const response = await retryRequest(
          SynchroRepository.sync_cast_only_votec_tag_list,
          {
            shop_id: store.getters["shops/currentShop"].id,
            shop_site_id: props.com_data.id,
          }
        );
        if (response.data) {
          const tag_list = response.data.data.tag_list;
          for (let i = 0; i < tag_list.length; i++) {
            state.checkTagList.push(tag_list[i]);
          }
        }
      } catch (error) {
        state.isError = true;
      } finally {
        state.loadingFlg = false;
        if (state.checkTagList.length == 0) {
          await ctx.refs.observer.validate();
        }
      }
    };

    const init = async () => {
      // タグリスト取得
      getTagList();

      // cast_propにキーを設定
      for (let key in items) {
        set(state.cast_prop, key, null);
        if (key == "lady_rookie") {
          // 新人属性に初期値を設定
          set(state.cast_prop, key, "");
        }
      }
      Object.keys(props.com_data.cast_prop).forEach(function (key) {
        set(state.cast_prop, key, props.com_data.cast_prop[key]);
      });
      // 読み込み時のデータを保持(保存前に比較するため)
      state.keepData.cast_prop = Object.assign({}, state.cast_prop);

      await reflectCastProps();
    };

    init();

    // onMounted(async () => {
    //   await getTagList();
    // });

    // チェック処理
    const checkValid = async () => {
      // 事前チェック処理
      state.errorElement = null;
      const isValid = await ctx.refs.observer.validate();
      if (!isValid) {
        let item_name = "";
        Object.keys(ctx.refs.observer.errors).forEach(function (key) {
          if (ctx.refs.observer.errors[key].length > 0) {
            item_name = key;
            return;
          }
        });
        const errorKey = utilFunc.getKeyByItemText(items, item_name);
        state.errorElement = ctx.refs[errorKey].$el;
      }
      return isValid;
    };

    const setErrorFocus = async () => {
      setTimeout(() => {
        state.errorElement.scrollIntoView({
          block: "center",
        });
      }, 300);
    };

    // 保存前にcastPropsの値を整理する(媒体コピー処理からsetCastPropsで呼ばれる)
    const setCastProps = async () => {
      for (let key in state.cast_prop) {
        if (key == "lady_lmsg") {
          set(state.cast_prop, key, refCommentByCastCkeditor.value.editorData);
        }
        if (key == "lady_mesg") {
          set(state.cast_prop, key, refCommentByShopCkeditor.value.editorData);
        }
        if (key == "tag_list") {
          set(
            state.cast_prop,
            key,
            state.checkTagListSelected.length == 0
              ? ""
              : JSON.stringify(state.checkTagListSelected)
          );
        }
      }
    };

    const save = async () => {
      // 保存前にcastPropsの値を整理する
      await setCastProps();

      // 更新前と比べて差分があれば更新処理
      if (!utilFunc.compareObject(state.keepData.cast_prop, state.cast_prop)) {
        const prop_param = [];
        for (let key in state.cast_prop) {
          prop_param.push({
            cast_id: props.com_data.cast_id,
            key: props.com_data.prefix + "__" + key,
            value: state.cast_prop[key] ?? "",
          });
        }
        await CastPropsRepository.save_all({ cast_prop: prop_param })
          .then((response) => {
            if (response.data) {
              // データ追加OK
            }
          })
          .catch((error) => {
            throw (
              "ERROR:cast_manager_wordpress.vue/save CastPropsRepository.save_all (" +
              error +
              ")"
            );
          });
      }
      return true;
    };

    const onHtmlClear = (mode) => {
      let mode_label = "";
      if (mode == "shop") {
        mode_label = "店舗からのメッセージ";
      } else {
        mode_label = "女性からのメッセージ";
      }
      if (
        !window.confirm(
          mode_label + "のHTMLに入力された内容をクリアします。よろしいですか？"
        )
      ) {
        return;
      }
      if (mode == "shop") {
        state.cast_prop.lady_mesg = "";
        if (refCommentByShopCkeditor.value) {
          refCommentByShopCkeditor.value.editorData = "";
        }
      } else {
        state.cast_prop.lady_lmsg = "";
        if (refCommentByCastCkeditor.value) {
          refCommentByCastCkeditor.value.editorData = "";
        }
      }
    };

    return {
      props,
      setting,
      rookieItem,
      items,
      ...toRefs(state),
      checkValid,
      setErrorFocus,
      save,
      refCommentByShopCkeditor,
      refCommentByCastCkeditor,
      onHtmlClear,
      setCastProps,
    };
  },
});
</script>

<style scoped></style>
